import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ColActionId, Detail, DetailAction, IconType, IoniconsOutline} from '@pt/pt-models';

@Component({
  selector: 'pt-details-viewer',
  templateUrl: 'details-viewer.component.html',
  styles: [
    `
      .dviewer-actions {
        margin-top: 10px;
        margin-left: 10px;
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .dviewer-actions_left {
        gap: 5px;
        width: 100%;
        display: inline-flex;
        align-items: center;

      }

      .disabled-first {
        color: #33333399;
      }
      .dviewer-actions_right {
        gap: 5px;
        width: 100%;
        align-items: center;
        display: inline-flex;
        justify-content: flex-end;
      }

      .dviewer-attribute-container {
        width: 100%;
        margin-top: 15px;
      }

      .flip-icon {
        transform: rotateX(180deg);
      }

      .space-no-more {
        width: 100%;
        height: 23px;
        position: relative;
      }
      .btn-more {
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        height: 23px;
        font-size: 12px;
        outline: none;
        box-shadow: none;
      }

      .btn-more:hover {
        background: #f6f6f6;
      }

      .btn-action {
        margin-left: 5px;
        padding: 0.25rem 22px
      }

      .btn-action:disabled {
        /*color: #6c757d;*/
        cursor: not-allowed;
        background-color: transparent;
      }
    `
  ]
})

export class DetailsViewerComponent implements OnChanges {

  @Input() details: Detail[] = [];
  @Output() clickAction = new EventEmitter<ColActionId>();


  public iconType = IconType.IONIC_ICON;
  public iconArrow = IoniconsOutline.arrowDown;
  public iconSize = 12;
  public enableExpand = false;
  public ColActionId = ColActionId;
  public isCollapsedOtherAttributes = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.details) {
      const currentDetail: Detail[] = changes.details.currentValue || [];
      this.enableExpand = false;
      currentDetail.forEach(detail => {
        detail?.body?.attributes?.forEach(attribute => {
          if (!attribute.showInAll) {
            this.enableExpand = true;
          }
        });
      });
    }
  }

  onClickAction(d: DetailAction) {
    const id = d.id as ColActionId;
    if (id !== null && id !== undefined) {
      this.clickAction.emit(id);
    }
  }
}
